import tw from 'tailwind-styled-components'
import {getRing, RingColor, RingSize} from '@components/common/base/common/ring'
import {DivWithHint} from '@components/common/hint/hint'
import {cn} from '@containers/html-utils'
import {AvatarSize} from './types'
import {getOutlineSize, getSize} from './utils'

const disabledMixin = 'opacity-50'

export const TwAvatar = tw(DivWithHint)<{
  $size: AvatarSize
  $hideOutline: boolean
  $outlineColor: RingColor
  $outlineSize?: RingSize
  $disabled?: boolean
}>`
  select-none
  rounded-full
  relative
  flex-shrink-0
  bg-center
  bg-no-repeat
  bg-cover
  ${p =>
    cn(
      getSize(p.$size),
      !p.$hideOutline &&
        getRing(p.$outlineSize ?? getOutlineSize(p.$size), p.$outlineColor),
      p.$disabled && disabledMixin
    )}
`
TwAvatar.displayName = 'TwAvatar'

export const TwShortName = tw.div`
  h-full
  flex
  items-center
  justify-center
  text-generic-white
`
TwShortName.displayName = 'TwDisplayName'

export const TwStatus = tw.div`
  absolute
  bottom-0
  left-0
`
TwStatus.displayName = 'TwStatus'

export const TwAvatarGroup = tw.div<{
  $disabled?: boolean
  $interactable?: boolean
}>`
  isolate
  flex
  flex-row
  items-center
  ${p => cn(p.$disabled && disabledMixin, p.$interactable && 'cursor-pointer')}
`
TwAvatarGroup.displayName = 'TwAvatarGroup'

export const TwAvatarStack = tw.div`
  isolate
  w-fit
  flex
  items-center
`
